/*
  Electrolytes LP shared blend state (page.electrolytes-lp).

  One page-wide selected blend ("unsweetened" | "nectar") so S2 cards, S5 toggle, S9 buy box,
  the Close cards and the mobile sticky bar stay in sync.

  API (window.ElxLp):
    ElxLp.getBlend()                 -> current blend key
    ElxLp.setBlend(key, sourceEl?)   -> sets it and dispatches "elx:blend-change" on document
                                        with detail { blend, source }
    ElxLp.scrollToBuy(key?)          -> optionally sets the blend, then scrolls to [data-elx-buy]
  Markup hooks handled here (no section JS needed for these):
    [data-elx-select-blend="<key>"]  click sets the blend
    [data-elx-scroll-buy]            click scrolls to the buy box (with the element's
                                     data-elx-select-blend applied first, if present)
    [data-elx-scroll-to="#id"]       click smooth-scrolls to an anchor
    a[href^="#"] inside .elx-lp or .elx-section
                                     smooth-scrolls to the matching id when it exists on the
                                     page; bare "#" and unknown hashes keep the browser default
  Sections listen with:
    document.addEventListener('elx:blend-change', (e) => { ... e.detail.blend ... });
*/
(() => {
  if (window.ElxLp) return;

  const BLENDS = ['unsweetened', 'nectar'];
  let blend = BLENDS[0];

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const scrollToEl = (el) => {
    if (!el) return;
    el.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    if (!el.matches('a[href], button, input, select, textarea, [tabindex]')) el.setAttribute('tabindex', '-1');
    el.focus({ preventScroll: true });
  };

  const api = {
    blends: BLENDS.slice(),
    getBlend: () => blend,
    setBlend(key, source) {
      if (!BLENDS.includes(key) || key === blend) return;
      blend = key;
      document.documentElement.dataset.elxBlend = key;
      document.dispatchEvent(new CustomEvent('elx:blend-change', { detail: { blend: key, source: source || null } }));
    },
    scrollToBuy(key) {
      if (key) api.setBlend(key);
      scrollToEl(document.querySelector('[data-elx-buy]'));
    },
  };

  window.ElxLp = api;
  document.documentElement.dataset.elxBlend = blend;

  const hashTarget = (link) => {
    const hash = link.getAttribute('href') || '';
    if (hash.length < 2) return null;
    const id = hash.slice(1);
    let target = document.getElementById(id);
    if (!target) {
      try {
        target = document.getElementById(decodeURIComponent(id));
      } catch (error) {
        target = null;
      }
    }
    return target;
  };

  const scrollToHash = (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href^="#"]');
    if (!link || !link.closest('.elx-lp, .elx-section')) return;
    const target = hashTarget(link);
    if (!target) return;
    event.preventDefault();
    scrollToEl(target);
  };

  document.addEventListener('click', (event) => {
    const scrollBuy = event.target.closest('[data-elx-scroll-buy]');
    if (scrollBuy) {
      event.preventDefault();
      api.scrollToBuy(scrollBuy.dataset.elxSelectBlend);
      return;
    }
    const select = event.target.closest('[data-elx-select-blend]');
    if (select) api.setBlend(select.dataset.elxSelectBlend, select);
    const anchor = event.target.closest('[data-elx-scroll-to]');
    if (anchor) {
      const target = document.querySelector(anchor.dataset.elxScrollTo);
      if (target) {
        event.preventDefault();
        scrollToEl(target);
      }
      return;
    }
    scrollToHash(event);
  });
})();
